module.exports = __webpack_public_path__ + "img/rooms-screenshot.56c05c86.png";